import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import OpportunitySourceService from "../../../Services/OpportunitySource.service";
const makeSearchArgs = {
    loadOptions: (search, options) => OpportunitySourceService.search({
        query: search,
        active: options.active,
    }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const OpportunitySourceSearch = makeSearch(makeSearchArgs);
export const OpportunitySourceMultiSearch = makeMultiSearch(makeSearchArgs);
